<template>
  <div>
     
  </div>
</template>
<script>
import md5 from 'md5'
  export default {
    methods: {
      goToHRDSchedule() {
        const userInfo = this.userInfo || {};
        if(userInfo.email){
          this.HRDScheduleAccount()
        }else{
          let hashEmail = userInfo.email ? md5(userInfo.email) : '';
          if (!hashEmail && userInfo.email) {
            hashEmail = md5(userInfo.email);
          }

          if (this.userInfo.name) {
            const hashId = userInfo['custom:emp_code'] ? md5(userInfo['custom:emp_code']) : '';
            window.open(`https://kidd.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
            this.$router.push('/');
          } else if (this.userInfo.name) {
            const hashId = userInfo['custom:emp_code'] ? md5(userInfo['custom:emp_code']) : '';
            window.open(`https://kidd.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
            this.$router.push('/');
          }
        }
      },
      HRDScheduleAccount(){
        const userInfo = this.userInfo || {};
        let hashEmail = userInfo.email ? md5(userInfo.email) : '';
        let hashId = userInfo['custom:emp_code'] ? md5(userInfo['custom:emp_code']) : '';
        window.open(`https://kidd.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
        this.$router.push('/');
      }
    },
    mounted () {
      this.goToHRDSchedule()
    },
    computed: {
      userInfo() {
        return this.$root.decryptedUser;
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>